export const tokens = {
    layout: {
        gap: {
            mobile: 16,
            desktop: 20,
        },
    },
    group: {
        gap: {
            mobile: 10,
            desktop: 20,
        },
    },
    search: {
        minWidth: 200,
    },
};
